const Input = ({ className = "", compact = false, error = false, ...props }) => {
  return (
    <input
      {...props}
      aria-invalid={error || props['aria-invalid']}
      className={`photon-field ${className} bg-fill-hex-fafbfe dark:bg-fill-navigation-surface-dark block w-full ${compact ? "px-2.5 py-1.5 rounded-md" : "p-[10px] rounded-[10px]"} text-[13px] text-ink-ink dark:text-ink-white placeholder-ink-copy-hover outline-none border-[0.5px] ${error ? "photon-field-invalid border-edge-red-500" : "border-edge-hex-d8d8d8 dark:border-edge-hex-aaaaaa50"} placeholder:italic disabled:opacity-50 disabled:cursor-not-allowed`}
    ></input>
  );
};

export default Input;
